import React from 'react'
import { useSelector } from 'react-redux'
import { Redirect } from 'react-router-dom'

import { selectIsAuthed } from '@/ducks/auth/auth.selectors'

interface ProtectedRouteProps {
  element: React.JSX.Element
}

const ProtectedRoute: React.FC<ProtectedRouteProps> = ({
  element,
  ...rest
}) => {
  const isAuthenticated = useSelector(selectIsAuthed)

      return isAuthenticated ? element : (
        // @ts-ignore
        <Redirect to="/login" />
      )
}

export default ProtectedRoute
